import classes from "./CarouselHeroSection.module.css";

import SimpleCarousel from "../../../generic components/SimpleCarousel/SimpleCarousel";
import OptimizedImage from "../../../components/OptimizedImage";

export default function CarouselHeroSection(props) {
  function displayCarouselItems(images) {
    return images.map((item, index) => (
      <OptimizedImage
        key={index}
        alt="Students walking along a scenic overlook"
        className={classes.carouselImage}
        sources={[
          {
            type: "image/webp",
            srcSet: item,
          },
        ]}
        fallback={{
          src: "../../assets/imgs/notFound/fallback-image.png",
        }}
      />
    ));
  }

  return (
    <section
      className={classes.hero}
      style={{ "--carousel-tint": props.tintColor }}
    >
      <SimpleCarousel
        autoPlay
        autoPlayInterval={3000}
        infinite
        mouseTracking
        items={displayCarouselItems(props.images)}
      />
      <div className={classes.heroContent}>
        {props.title && <h1 className={classes.heroTitle}> {props.title}</h1>}
        {props.btn && (
          <a href="programs" className={classes.heroBtn}>
            {props.btn}
          </a>
        )}
      </div>
    </section>
  );
}
